import { PropType } from 'vue';
import { Vue, Options } from 'vue-class-component';
import ObjectSettings from '@/views/components/ObjectSettings/ObjectSettings.vue';
import { DefaultDevicesSettingsDTO } from '@/../client-generator/generated-clients/plants';
import { mapGetters } from 'vuex';

@Options({
  name: 'DialogObjectSettings',
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    defaultSettings: {
      type: Object as PropType<DefaultDevicesSettingsDTO>,
      required: true,
    },
  },
  watch: {
    isVisible(newValue) {
      this.isDialogVisible = newValue;
    },
  },
  emits: ['hide-dialog', 'confirm'],
  components: {
    ObjectSettings,
  },
  computed: {
    ...mapGetters('UI', ['plantRoomObjectSettingsEditDialog']),
  },
})
export default class DialogObjectSettings extends Vue {
  isVisible!: boolean;
  isDialogVisible = false;

  mounted() {
    this.isDialogVisible = this.isVisible;
  }

  handleHideDialog() {
    this.isDialogVisible = false;
  }

  doHideDialog() {
    this.$emit('hide-dialog');
  }

  doConfirm() {
    this.$emit('confirm');
    this.handleHideDialog();
  }
}
